import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import { RxCross1 } from 'react-icons/rx';
import { useSelector, useDispatch } from 'react-redux';
import { setRows, addRow, removeRow, removeSingleRow, updateRow, clearRows } from '../../../Redux/actions/rowActions';
import { IoAddSharp } from 'react-icons/io5';
import { BarLoader } from 'react-spinners';
import AsyncSelect from 'react-select/async';

const UpdateItemGrid = ({ onRequisitionData, setLoader, loder, itemData, selectedCheck, handleVatChange, isDiscountPercentage, currencyPrecision }) => {
    const rows = useSelector((state) => state.rows.rows);
    const [itemOptions, setItemOptions] = useState([]);
    const [descriptionOptions, setDescriptionOptions] = useState([]);
    const [vat, setvat] = useState([]);
    const dispatch = useDispatch();
    const apiService = new ApiService();

    const [page, setPage] = useState(1);
    const [desPage, setDecPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loader, setLoaders] = useState(false);

    const netAmount = rows.reduce((sum, row) => sum + (parseFloat(row?.amount) || 0), 0);
    const totalVat = rows.reduce((sum, row) => sum + (parseFloat(row?.vatAmount) || 0), 0);
    const totalDiscountAmount = rows.reduce((sum, row) => sum + (parseFloat(row?.discountAmount) || 0), 0);
    const totalDiscount = rows.reduce((sum, row) => sum + (parseFloat(row?.discount) || 0), 0);
    const calculatedTotal = rows.reduce((sum, row) => sum + (parseFloat(row?.amount - row?.vatAmount) || 0), 0);
    useEffect(() => {
        if (rows[0]?.ItemNo) {
            updatevat();
        }
    }, [selectedCheck]);
    // Replace the existing useEffects in ItemGrid with these:

    useEffect(() => {
        fetchItemNo('', 1);
        fetchItemDesc('', 1);
        getVat();
    }, []);

    // Clear rows when itemData changes (important for dropdown changes)
    useEffect(() => {
        if (itemData?.requisitionNo) {
            // Clear existing rows when new itemData comes in
            dispatch(clearRows());
            setRows([]);
        }
    }, [itemData?.requisitionNo]); // React to requisition number changes

    // Process items when all dependencies are ready
    useEffect(() => {
        if (itemData) {
            getItems();
        }
    }, [itemData, selectedCheck, isDiscountPercentage]); // Add all necessary dependencies

    // Update VAT when selectedCheck changes
    useEffect(() => {
        if (rows.length > 0 && rows[0]?.ItemNo) {
            updatevat();
        }
    }, [selectedCheck]);

    const updatevat = async () => {
        try {
            let vatParam = `?toPurchase=true`;
            const vat = await apiService.getApiParamater('GET_INV_TAX', vatParam);
            setvat(vat.data.result);
            const updatedRows = rows.map((row) => ({ ...row }));
            const apiPromises = updatedRows.map(async (row, index) => {
                const selectedVat = vat.data.result?.find((tax) => tax.description === row?.vatDec);
                let amount = row?.qty * row?.baseAmount;
                const perAmount = (amount / 100) * (selectedVat?.rate || 0);
                let excludedAmount = amount + perAmount;
                const calculatedAmount = selectedCheck ? excludedAmount : amount;
                let discountamount = 0;
                if (isDiscountPercentage) {
                    discountamount = row?.discount;
                } else {
                    const discountAmount = (row?.discount / 100) * calculatedAmount;
                    discountamount = discountAmount;
                }
                let finalAmount = 0;
                if (isDiscountPercentage) {
                    finalAmount = calculatedAmount - (row?.discount || 0);
                } else {
                    const discountAmount = (row?.discount / 100) * calculatedAmount;
                    finalAmount = calculatedAmount - (discountAmount || 0);
                }
                updatedRows[index].calculatedAmount = calculatedAmount;
                updatedRows[index].amount = calculatedAmount;
                updatedRows[index].vat = selectedVat?.rate || 0;
                updatedRows[index].vatDec = selectedVat?.description || 0;
                updatedRows[index].vatAmount = perAmount;
                updatedRows[index].discountAmount = discountamount;
                updatedRows[index].calculatedAmount = calculatedAmount;
                updatedRows[index].discount = row?.discount;
            });
            await Promise.all(apiPromises);
            setRows(updatedRows);
            onRequisitionData(updatedRows);
            dispatch(setRows(updatedRows));
        } catch (error) {
            console.error('Error updating rows with new stock:', error);
        }
    };
    const getVat = async () => {
        let vatParam = `?toPurchase=true`;
        const vat = await apiService.getApiParamater('GET_INV_TAX', vatParam);
        setvat(vat.data.result);
    };
    const getItems = async () => {
        try {
            let vatParam = `?toPurchase=true`;
            const vat = await apiService.getApiParamater('GET_INV_TAX', vatParam);
            setvat(vat.data.result);
            if (itemData?.requisitionNo) {
                setLoader(true);
                let param = `?Id=${itemData?.requisitionNo}`;
                const response = await apiService.getApiParamater('GET_PR', param);
                const selectedPR = response?.data?.result[0];
                if (!selectedPR) {
                    console.error('Selected PR not found');
                    return;
                }
                const prDetails = selectedPR?.prDetails || [];
                const sortedPrDetails = [...prDetails].sort((a, b) => a.srno - b.srno);
                const formattedRowsPromises = itemData?.poDetails?.map(async (detail, index) => {
                    const params = new URLSearchParams();
                    params.append('ItemNo', detail.itemCode || '');
                    const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
                    let selecteditem = response?.data?.result[0]
                    const selectedItem = rows?.find((item) => item?.itemDescription === detail?.itemDescription);
                    const selectedPritem = sortedPrDetails[index];
                    const selectedVat = vat.data.result?.find((tax) => tax?.description === selecteditem?.vat);

                    if (!selecteditem) {
                        console.error(`Selected item with description ${detail?.itemDescription} not found`);
                        return null;
                    }
                    let amount = detail?.qty * detail.unitPrice;
                    const perAmount = (amount / 100) * selectedVat?.rate;
                    let excludedAmount = amount + perAmount;
                    const calculatedAmount = selectedCheck ? excludedAmount : amount;
                    let discountamount = 0;
                    if (isDiscountPercentage) {
                        const discountAmount = (detail?.discount / 100) * calculatedAmount;
                        discountamount = discountAmount;
                    } else {
                        discountamount = detail?.discount;
                    }
                    let finalAmount = 0;
                    if (isDiscountPercentage) {
                        const discountAmount = (selectedItem?.discount / 100) * calculatedAmount;
                        finalAmount = calculatedAmount - (discountAmount || 0);
                    } else {
                        finalAmount = calculatedAmount - (selectedItem?.discount || 0);
                    }
                    return {
                        requisitionNo: itemData.requisitionNo || '',
                        srno: selectedPritem?.srno,
                        ItemNo: detail.itemCode,
                        itemDescription: detail?.itemDescription,
                        qty: detail?.qty,
                        stock: selecteditem.convToInvUOM * detail?.qty,
                        baseQty: selecteditem.convToInvUOM,
                        uom: detail?.uom,
                        baseAmount: detail.unitPrice?.toFixed(currencyPrecision || 3),
                        specification: selectedPritem ? selectedPritem?.specification : '',
                        amount: finalAmount?.toFixed(currencyPrecision || 3),
                        vat: selectedVat?.rate || 0,
                        vatDec: selectedVat?.description,
                        vatAmount: perAmount?.toFixed(currencyPrecision || 3),
                        discount: selectedItem?.discount,
                        calculatedAmount: calculatedAmount?.toFixed(currencyPrecision || 3),
                        discountAmount: discountamount?.toFixed(currencyPrecision || 3),
                    };
                }).filter((row) => row !== null);
                const formattedRows = await Promise.all(formattedRowsPromises);
                if (formattedRows?.length > 0) {
                    setLoader(false);
                    setRows(formattedRows);
                    onRequisitionData(formattedRows);
                    dispatch(setRows(formattedRows));
                }
            } else {
                setLoader(true);

                const formattedRowsPromises = itemData?.poDetails?.map(async (detail, index) => {
                    const params = new URLSearchParams();
                    params.append('ItemNo', detail.itemCode || '');
                    const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
                    let selecteditem = response?.data?.result[0]

                    const selectedItem = rows?.find((item) => item?.itemDescription === detail?.itemDescription);
                    const selectedVat = vat.data.result?.find((tax) => tax?.description === selecteditem?.vat);
                    let amount = detail?.qty * detail.unitPrice;
                    const perAmount = (amount / 100) * selectedVat?.rate;
                    let excludedAmount = amount + perAmount;
                    const calculatedAmount = selectedCheck ? excludedAmount : amount;
                    let discountamount = 0;
                    if (isDiscountPercentage) {
                        const discountAmount = (detail?.discount / 100) * calculatedAmount;
                        discountamount = discountAmount;
                    } else {
                        discountamount = detail?.discount;
                    }
                    let finalAmount = 0;
                    if (isDiscountPercentage) {
                        const discountAmount = (selectedItem?.discount / 100) * calculatedAmount;
                        finalAmount = calculatedAmount - (discountAmount || 0);
                    } else {
                        finalAmount = calculatedAmount - (selectedItem?.discount || 0);
                    }
                    return {
                        requisitionNo: itemData?.requisitionNo || '',
                        srno: detail?.srno,
                        ItemNo: detail.itemCode,
                        itemDescription: detail?.itemDescription,
                        qty: detail?.qty,
                        stock: selecteditem.convToInvUOM * detail?.qty,
                        baseQty: selecteditem.convToInvUOM,
                        uom: detail?.uom,
                        baseAmount: detail.unitPrice?.toFixed(currencyPrecision || 3),
                        specification: detail ? detail?.specification : '',
                        amount: finalAmount?.toFixed(currencyPrecision || 3),
                        vat: selectedVat?.rate || 0,
                        vatDec: selectedVat?.description,
                        vatAmount: perAmount?.toFixed(currencyPrecision || 3),
                        discount: selectedItem?.discount,
                        calculatedAmount: calculatedAmount?.toFixed(currencyPrecision || 3),
                        discountAmount: discountamount?.toFixed(currencyPrecision || 3),
                    };

                }).filter(row => row !== null);
                const formattedRows = await Promise.all(formattedRowsPromises);
                if (formattedRows?.length > 0) {
                    setLoader(false);
                    setRows(formattedRows?.reverse());
                    onRequisitionData(formattedRows);
                    dispatch(setRows(formattedRows));
                }
            }
        } catch (error) {
            setLoader(false);
            console.error('Error fetching items:', error);
        }
    };
    const fetchItemNo = async (inputValue = '', pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('ItemNo', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
            const fetchedItems = response.data.result.map((item) => ({
                label: item.itemNo,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            setItemOptions((prevAccounts) => [...prevAccounts, ...fetchedItems]);
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error('Error fetching account data:', error);
            setLoaders(false);
            return [];
        }
    };
    const fetchItemDesc = async (inputValue = '', pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('ItemDescription', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
            const fetchedItems = response.data.result.map((item) => ({
                label: item.itemDescription,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            setDescriptionOptions((prevAccounts) => [...prevAccounts, ...fetchedItems]);
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error('Error fetching account data:', error);
            setLoaders(false);
            return [];
        }
    };
    const loadOptions = async (inputValue, callback) => {
        const options = await fetchItemNo(inputValue, 1);
        callback(options);
    };
    const loadDescOptions = async (inputValue, callback) => {
        const options = await fetchItemDesc(inputValue, 1);
        callback(options);
    };
    const loadMoreOptions = async () => {
        if (!hasMore || loader) return;
        setPage((prevPage) => prevPage + 1);
        await fetchItemNo('', page + 1);
    };
    const loadMoreDescOptions = async () => {
        if (!hasMore || loader) return;
        setDecPage((prevPage) => prevPage + 1);
        await fetchItemDesc('', desPage + 1);
    };
    const handleInputChange = async (index, fieldName, value) => {
        const DB = localStorage.getItem('DataBase');
        const companies = JSON.parse(localStorage.getItem('UserCompanies') || '[]');
        const defaultCompany = companies.find(comp => comp.dataDB === DB);
        const companyName = defaultCompany?.companyName?.toUpperCase() || '';
        const isYusuf = companyName.includes("KANOO") || companyName.includes("ACCOUNTCODE");

        if (isYusuf === false) {
            const isDuplicate = rows.some((row, rowIndex) => rowIndex !== index && (row.itemNo === value || row.itemDescription === value));
            if (isDuplicate) {
                toast.error('Please choose a different item.');
                return;
            }
        }
        if (fieldName === 'qty' && value < 0) {
            toast.warning('Quantity cannot be less than 0.');
            return;
        }
        const updatedRows = rows
            ?.map(async (row, rowIndex) => {
                if (rowIndex === index) {
                    const updatedRow = { ...row, [fieldName]: value, srno: ('0' + (index + 1)).slice(-2) };
                    if (fieldName === 'qty') {
                        const quantity = parseFloat(value);
                        if (quantity < 0) {
                            toast.warning('Quantity cannot be less than 0.');
                            return;
                        }
                    }
                    if (fieldName === 'ItemNo') {
                        const getunit = await apiService.getApiParamater('GET_ITEM_PACK', `?ItemNo=${value}`);
                        let selectedItem = getunit?.data?.result[0];
                        const selectedVat = vat?.find((tax) => tax.description === selectedItem?.vat);
                        if (selectedItem) {
                            updatedRow.itemDescription = selectedItem?.itemDescription;
                            updatedRow.ItemNo = selectedItem?.itemNo;
                            updatedRow.requisitionNo = selectedItem?.itemDescription;
                            updatedRow.uom = selectedItem.baseUnit;
                            updatedRow.specification = selectedItem?.specification;
                            updatedRow.vatDec = selectedVat?.description;
                            updatedRow.vat = selectedVat?.rate;
                            updatedRow.stock = 0;
                            updatedRow.baseAmount = selectedItem?.avgPrice?.toFixed(currencyPrecision || 3) || 0;
                            updatedRow.baseQty = parseFloat(selectedItem.convToInvUOM);
                        }
                    } else if (fieldName === 'itemDescription') {
                        const getunit = await apiService.getApiParamater('GET_ITEM_PACK', `?ItemDescription=${value}`);
                        let selectedItem = getunit?.data?.result[0];
                        ;
                        const selectedVat = vat?.find((tax) => tax.description === selectedItem?.vat);
                        if (selectedItem) {
                            updatedRow.specification = selectedItem?.specification;
                            updatedRow.recordId = selectedItem?.itemNo;
                            updatedRow.ItemNo = selectedItem?.itemNo;
                            updatedRow.stock = 0;
                            updatedRow.uom = selectedItem.baseUnit;
                            updatedRow.baseQty = parseFloat(selectedItem.convToInvUOM);
                            updatedRow.vatDec = selectedVat?.description;
                            updatedRow.vat = selectedVat?.rate;
                            updatedRow.baseAmount = selectedItem?.avgPrice?.toFixed(currencyPrecision || 3) || 0;
                        }
                    }
                    if (fieldName === 'qty') {
                        const quantity = parseFloat(value);
                        const convrate = updatedRow?.baseQty;
                        const baseQty = convrate || 1;
                        updatedRow.stock = convrate * quantity || 0;
                        updatedRow.baseQty = parseFloat(baseQty);
                    }
                    if (fieldName === 'discount') {
                        const discount = parseFloat(value);
                        const vatDec = updatedRow?.vatDec;
                        const quantity = parseFloat(updatedRow?.qty);
                        const unitPrice = parseFloat(updatedRow.baseAmount);
                        const selectedVat = vat?.find((tax) => tax?.description === vatDec);
                        const amount = quantity * unitPrice;
                        const vatAmount = (amount / 100) * (selectedVat?.rate || 0);
                        const excludedAmount = amount + vatAmount;
                        const calculatedAmount = selectedCheck ? excludedAmount : amount;
                        let discountamount = 0;
                        if (isDiscountPercentage) {
                            discountamount = discount;
                        } else {
                            const discountAmount = (discount / 100) * calculatedAmount;
                            discountamount = discountAmount;
                        }
                        let finalAmount = 0;
                        if (!isNaN(discount) && discount >= 0) {
                            if (isDiscountPercentage) {
                                finalAmount = calculatedAmount - discount;
                            } else {
                                const discountAmount = (discount / 100) * calculatedAmount;
                                finalAmount = calculatedAmount - discountAmount;
                            }
                        } else {
                            finalAmount = calculatedAmount;
                        }

                        updatedRow.amount = finalAmount;
                        updatedRow.calculatedAmount = calculatedAmount;
                        updatedRow.discountAmount = discountamount;
                        updatedRow.discount = discount;
                    }
                    if (fieldName === 'qty' || fieldName === 'baseAmount') {
                        const convrate = updatedRow?.baseQty;
                        const selectedvat = updatedRow?.vatDec;
                        const selectedVat = vat?.find((tax) => tax?.description === selectedvat);
                        const quantity = parseFloat(updatedRow?.qty);
                        const discount = updatedRow.discount;
                        const unitPrice = parseFloat(updatedRow.baseAmount || 0);
                        let amount = quantity * unitPrice;
                        const perAmount = (amount / 100) * selectedVat?.rate;
                        let excludedAmount = amount + perAmount;
                        const calculatedAmount = selectedCheck ? excludedAmount : amount;
                        let discountamount = 0;
                        if (isDiscountPercentage) {
                            discountamount = discount;
                        } else {
                            const discountAmount = (discount / 100) * calculatedAmount;
                            discountamount = discountAmount;
                        }
                        let finalAmount = 0;
                        if (!isNaN(discount) && discount >= 0) {
                            if (isDiscountPercentage) {
                                finalAmount = calculatedAmount - discount;
                            } else {
                                const discountAmount = (discount / 100) * calculatedAmount;
                                finalAmount = calculatedAmount - discountAmount;
                            }
                        } else {
                            finalAmount = calculatedAmount;
                        }
                        updatedRow.amount = finalAmount;
                        updatedRow.discount = discount;
                        updatedRow.stock = convrate * quantity || 0;
                        updatedRow.discountAmount = discountamount;
                        updatedRow.calculatedAmount = calculatedAmount;
                        updatedRow.vatAmount = perAmount;
                    }
                    if (fieldName === 'vat') {
                        let amount = row?.qty * row?.baseAmount;

                        const perAmount = (amount / 100) * (value?.rate || 0);
                        let excludedAmount = amount + perAmount;
                        const calculatedAmount = selectedCheck ? excludedAmount : amount;
                        let discountamount = 0;
                        if (isDiscountPercentage) {
                            discountamount = row?.discount;
                        } else {
                            const discountAmount = (row?.discount / 100) * calculatedAmount;
                            discountamount = discountAmount;
                        }
                        let finalAmount = 0;
                        if (isDiscountPercentage) {
                            finalAmount = calculatedAmount - row?.discount;
                        } else {
                            const discountAmount = (row?.discount / 100) * calculatedAmount;
                            finalAmount = calculatedAmount - discountAmount;
                        }
                        updatedRow.calculatedAmount = parseFloat(calculatedAmount);
                        updatedRow.amount = parseFloat(calculatedAmount);
                        updatedRow.vatDec = value?.description;
                        updatedRow.vat = value?.rate;
                        updatedRow.vatAmount = parseFloat(perAmount);
                    }
                    return updatedRow;
                }
                return row;
            })
            .filter((row) => row !== null);
        const formattedRows = await Promise.all(updatedRows);
        setRows(formattedRows);
        dispatch(setRows(formattedRows));
        onRequisitionData(formattedRows);
    };
    const addNewRow = () => {
        const newRow = {
            srno: '',
            ItemNo: '',
            requisitionNo: '',
            itemDescription: '',
            branch: '',
            qty: '',
            uom: '',
            baseQty: '',
            baseAmount: '',
            amount: '',
            stock: '',
            bol: '',
        };
        dispatch(addRow(newRow));
        const updatedRows = [...rows, newRow];
        onRequisitionData(updatedRows);
        dispatch(setRows(updatedRows));
    };
    const handleRemoveRow = (index) => {
        dispatch(removeSingleRow(index));
        const updatedRows = rows
            .filter((_, i) => i !== index)
            .map((row, i) => ({
                ...row,
                srno: i + 1,
            }));
        onRequisitionData(updatedRows);
        dispatch(setRows(updatedRows));
        setRows(updatedRows);
    };
    const preventNegativeSign = (e) => {
        if (e.key === '-' || e.key === '+') {
            e.preventDefault();
        }
    };
    return (
        <div>
            <div className="table-container p-2 mb-5" style={{ overflowX: 'auto', height: '400px' }}>
                {loder === true ? (
                    <div className="center p-5">
                        <BarLoader color="#6E5199" size={50} height={3} width={300} />
                    </div>
                ) : (
                    <table>
                        <thead className="dynoTable">
                            <tr>
                                <th></th>
                                <th>Sr no</th>
                                <th>Item No</th>
                                <th>Description</th>
                                <th>Item Specs</th>
                                <th>Qty</th>
                                <th>Packing UOM</th>
                                <th>Inventory Qty</th>
                                <th>Unit Price</th>
                                <th>Discount</th>
                                <th>VAT %</th>
                                <th>VAT Amount</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(rows) &&
                                [...rows] // clone to avoid mutating state
                                    .sort((a, b) => Number(a.srno) + Number(b.srno))
                                    .map((row, index) => (
                                        <tr key={index}>
                                            {itemData?.requisitionNo === '' ? (
                                                <td className="m-0 p-0" style={{ border: '1px solid rgba(118, 118, 118, 0.3)' }}>
                                                    <div className="center" onClick={() => handleRemoveRow(index)}>
                                                        {' '}
                                                        <RxCross1 size={15} />
                                                    </div>
                                                </td>
                                            ) : (
                                                <td className="m-0 p-0" style={{ border: '1px solid rgba(118, 118, 118, 0.3)' }}>
                                                    <div className="center">
                                                        {' '}
                                                        <RxCross1 size={15} />
                                                    </div>
                                                </td>
                                            )}
                                            <td className="m-0 p-0">
                                                <input className="p-2" type="text" value={row?.srno} disabled style={{ width: '120px' }} />
                                            </td>
                                            <td className="m-0 p-0">
                                                {itemData?.requisitionNo === '' ? (
                                                    <AsyncSelect
                                                        cacheOptions
                                                        value={{ value: row.ItemNo, label: row.ItemNo }}
                                                        options={itemOptions}
                                                        isDisabled={itemData?.eye === true ? true : false}
                                                        loadOptions={loadOptions}
                                                        onChange={(selectedOption) => handleInputChange(index, 'ItemNo', selectedOption.label)}
                                                        defaultOptions={itemOptions}
                                                        onMenuScrollToBottom={loadMoreOptions}
                                                    />
                                                ) : (
                                                    <td className="m-0 p-0">
                                                        <input className="p-2" disabled value={row?.ItemNo} style={{ width: '120px' }} />
                                                    </td>
                                                )}
                                            </td>
                                            <td className="m-0 p-0">
                                                {itemData?.requisitionNo === '' ? (
                                                    <AsyncSelect
                                                        cacheOptions
                                                        value={{ value: row.itemDescription, label: row.itemDescription }}
                                                        isDisabled={itemData?.eye === true ? true : false}
                                                        options={descriptionOptions}
                                                        loadOptions={loadDescOptions}
                                                        onChange={(selectedOption) => handleInputChange(index, 'itemDescription', selectedOption.label)}
                                                        className="w-100 p-0"
                                                        defaultOptions={descriptionOptions}
                                                        onMenuScrollToBottom={loadMoreDescOptions}
                                                    />
                                                ) : (
                                                    <td className="m-0 p-0">
                                                        <input className="p-2" disabled value={row?.itemDescription} style={{ width: '140px' }} />
                                                    </td>
                                                )}
                                            </td>
                                            <td className="m-0 p-0">
                                                <input
                                                    className="p-2"
                                                    type="text"
                                                    disabled={itemData?.requisitionNo === '' ? false : true}
                                                    value={row?.specification}
                                                    onChange={(e) => handleInputChange(index, 'specification', e.target.value)}
                                                    style={{ width: '120px' }}
                                                />
                                            </td>
                                            <td className="m-0 p-0">
                                                <input
                                                    className="p-2"
                                                    disabled={itemData?.requisitionNo === '' ? false : true}
                                                    onWheel={(e) => e.target.blur()}
                                                    style={{ width: '120px' }}
                                                    type="number"
                                                    value={row?.qty}
                                                    onChange={(e) => handleInputChange(index, 'qty', e.target.value)}
                                                    onKeyDown={preventNegativeSign}
                                                />
                                            </td>
                                            <td className="m-0 p-0">
                                                <input className="p-2" disabled={true} type="text" value={row?.uom} style={{ width: '140px' }} />
                                            </td>
                                            <td className="m-0 p-0">
                                                <input className="p-2" disabled type="text" value={row?.stock || 0} style={{ width: '140px' }} />
                                            </td>
                                            <td className="m-0 p-0">
                                                <input
                                                    className="p-2"
                                                    disabled={itemData?.requisitionNo === '' ? false : true}
                                                    onWheel={(e) => e.target.blur()}
                                                    style={{ width: '120px' }}
                                                    type="number"
                                                    value={row?.baseAmount}
                                                    onChange={(e) => handleInputChange(index, 'baseAmount', e.target.value)}
                                                    onKeyDown={preventNegativeSign}
                                                />
                                            </td>
                                            <td className="m-0 p-0">
                                                <input className="p-2" disabled
                                                    onChange={(e) => handleInputChange(index, 'discount', e.target.value)}
                                                    onKeyDown={preventNegativeSign} type="number" value={row?.discount} style={{ width: '120px' }} />
                                            </td>
                                            <td className="m-0 p-0">
                                                <Select
                                                    className="flex-grow-1"
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        padding: 10,
                                                    })}
                                                    value={{ value: row?.vatDec, label: row?.vatDec }}
                                                    options={vat?.map((vat) => ({ value: vat, label: vat?.description }))}
                                                    onChange={(selectedOption) => handleInputChange(index, 'vat', selectedOption.value)}
                                                />
                                            </td>
                                            <td className="m-0 p-0">
                                                <input
                                                    className="p-2"
                                                    type="text"
                                                    value={Number(row?.vatAmount || 0).toFixed(currencyPrecision || 0)}
                                                    disabled
                                                    style={{ width: '120px' }}
                                                />
                                            </td>
                                            <td className="m-0 p-0">
                                                <input
                                                    className="p-2"
                                                    disabled
                                                    style={{ width: '120px' }}
                                                    type="text"
                                                    value={row.amount === NaN ? 0 : Number(row.amount || 0).toFixed(currencyPrecision || 0) || 0}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                        </tbody>
                    </table>
                )}
                {itemData?.requisitionNo === '' ? (
                    <div className="d-flex gap-5">
                        <button className="mainbtn  mt-4 gap-3" onClick={addNewRow}>
                            <div>Add</div> <IoAddSharp color="#fff" className="center mt-1 mx-2" />{' '}
                        </button>
                    </div>
                ) : (
                    ''
                )}
            </div>
            <div className="d-flex justify-content-between boxs">
                <div className="d-flex gap-2">
                    <div className="totalhead center">Discount</div>
                    <div className="field">{`${totalDiscount.toFixed(currencyPrecision || 0)} ${isDiscountPercentage === true ? '%' : ' '}` || '---'}</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">Total Amount</div>
                    <div className="field">{calculatedTotal.toFixed(currencyPrecision || 0) || '---'}</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">Total Discount</div>
                    <div className="field">{totalDiscountAmount.toFixed(currencyPrecision || 0) || '---'}</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">Total Vat</div>
                    <div className="field">{totalVat.toFixed(currencyPrecision || 0) || '---'}</div>
                </div>
                <div className="d-flex gap-2">
                    <div className="totalhead center">Net Amount</div>
                    <div className="field">{netAmount.toFixed(currencyPrecision || 0) || '---'}</div>
                </div>
            </div>
        </div>
    );
};

export default UpdateItemGrid;